/**
 * booost's own Bootstrap modals carry `.modal` only while they are open.
 *
 * Mockup's pat-plone-modal (link and image dialogs in TinyMCE, easyform's
 * Settings, every Plone overlay) hides its backdrop on close only when
 * `$(".modal", $("body")).length < 1`. The design toolbar always renders the
 * customizer's "Show CSS" modal, closed but classed `modal`, so for a manager
 * that count never reached 0: after Cancel or Insert the 85 % dark backdrop
 * stayed up, swallowed every click, and the page looked frozen.
 *
 * So the markup ships as `booost-modal fade` with `display: none`, and the
 * class is lent for the time the modal is shown. Bootstrap does not need it
 * to find or open the element; its CSS variables and layout do, from
 * show.bs.modal on, which fires before the element is displayed.
 *
 * The same moment moves the modal to <body>. The toolbar's <li> is a stacking
 * context of its own, so a modal rendered there stayed under Bootstrap's
 * backdrops (z-index 1050, appended to <body>) whatever its own z-index.
 */

const PARKED = 'booost-modal'

document.addEventListener('show.bs.modal', (e) => {
  const el = e.target
  if (!el || !el.classList || !el.classList.contains(PARKED)) return
  el.classList.add('modal')
  if (el.parentElement !== document.body) document.body.appendChild(el)
})

document.addEventListener('hidden.bs.modal', (e) => {
  const el = e.target
  if (el && el.classList && el.classList.contains(PARKED))
    el.classList.remove('modal')
})
